import { HttpApiError, HttpApiGroup } from "@effect/platform";
import { Schema } from "effect";
import { endpoint } from "../auth/endpoint";
import { DatabaseError, DataIntegrityError } from "../auth/errors";
import { MessageId } from "../ids/definitions";

const SubmitAiGuidanceInput = Schema.Struct({
  messageId: MessageId,
  sentiment: Schema.Boolean,
  feedback: Schema.optional(Schema.String),
});

export const AiGuidanceGroup = HttpApiGroup.make("aiGuidance")
  .add(
    endpoint.merchant
      .post("submitAiGuidance", "/ai-guidance")

      .setPayload(SubmitAiGuidanceInput)
      .addSuccess(Schema.Void)
      .addError(HttpApiError.NotFound)
      .addError(HttpApiError.Forbidden)
      .addError(DatabaseError)
      .addError(DataIntegrityError),
  )
  .prefix("/api");
